export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-eye-d33b763ccc4c224a42e5172448a673b0.svg";